import { render, staticRenderFns } from "./chart.md?vue&type=template&id=13ac6509&"
import script from "./chart.md?vue&type=script&lang=js&"
export * from "./chart.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ac6509')) {
      api.createRecord('13ac6509', component.options)
    } else {
      api.reload('13ac6509', component.options)
    }
    module.hot.accept("./chart.md?vue&type=template&id=13ac6509&", function () {
      api.rerender('13ac6509', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/chart.md"
export default component.exports